import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Button } from 'semantic-ui-react';

import { clearReduxStore } from 'containers/InitialStore';

class CtAdminQna extends Component {
  constructor(props) {
    super(props);
  }

  clearAllStore = () => {
    const { Dispatch } = this.props;
    clearReduxStore(Dispatch, 'keep-login');
  };

  render() {
    const { clearAllStore } = this;

    return (
      <div>
        QnA!!
        <Button onClick={clearAllStore}>clearReduxStore</Button>
      </div>
    );
  }
}

CtAdminQna.propTypes = {};
CtAdminQna.defaultProps = {};

const mapStateToProps = state => ({
  //login: state.login.get('login')
});

const mapDispatchToProps = dispatch => ({
  //LoginActions: bindActionCreators(loginActions, dispatch),
  Dispatch: dispatch
});

export default connect(mapStateToProps, mapDispatchToProps)(
  //injectIntl(LoginPage)
  CtAdminQna
);



// WEBPACK FOOTER //
// ./src/script/containers/admin/CtAdminQna.js